import { combineReducers } from 'redux';

import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Outbound } from '../../model';
import { Actions, StoreState } from '../types';

interface OutboundById {
  [id: string]: Outbound | undefined
}

function outboundById(state: OutboundById = {}, action: Actions): OutboundById {
  switch (action.type) {
    case getType(actions.removeCommand): {
      const newState = { ...state }
      delete newState[action.payload]
      return newState
    }

    case getType(actions.updateMediaCommand): {
      const { command } = action.payload
      if (command.ExtendedInfo.Keys && command.ExtendedInfo.Keys.DSLKey && command.ExtendedInfo.Specific && command.ExtendedInfo.QueueItems) {
        //this is media item id
        const id = command.ExtendedInfo.Keys.DSLKey

        if (command.CommandType === "SHUTDOWN") {
          const newState = { ...state }
          delete newState[id]
          return newState
        }

        const contactId = command.ExtendedInfo.Specific.ContactId
        const primaryTelephoneNumber = command.ExtendedInfo.Specific.PrimaryTelephoneNumber
        const secondaryTelephoneNumber = command.ExtendedInfo.Specific.SecondaryTelephoneNumber
        const emailAddress = command.ExtendedInfo.Specific.EmailAddress
        const url = command.ExtendedInfo.Specific.Url
        const contactName = command.ExtendedInfo.Specific.ContactName
        const contactNote = command.ExtendedInfo.Specific.ContactNote
        const campaignId = command.ExtendedInfo.Specific.CampaignId
        const campaignName = command.ExtendedInfo.Specific.CampaignName

        if (!contactId || !primaryTelephoneNumber || !secondaryTelephoneNumber || !emailAddress || !url) break;

        const out = state[id]
        if (!out) {
          return {
            ...state,
            [id]: { contactId, primaryTelephoneNumber, secondaryTelephoneNumber, emailAddress, url, contactName, contactNote, campaignId, campaignName, sessions: [], codes: undefined, selectedCode: undefined, deferDate: undefined },
          }
        }
      }
      break;
    }

    case getType(actions.fetchOutboundDetailsResponse): {
      const { details } = action.payload
      const out = state[details.contactId]

      if (!out) {
        return {
          ...state,
          [details.contactId]: details,
        }
      }
      break;
    }

    case getType(actions.fetchOutboundCodeResponse): {
      const { mediaItemId, codes } = action.payload
      const out = state[mediaItemId]

      if (out) {
        return {
          ...state,
          [mediaItemId]: { ...out, codes: codes },
        }
      }
      break;
    }

    case getType(actions.removeMediaItem): {
      const out = state[action.payload]
      if (!out) { return state }

      const { [action.payload]: _, ...rest } = state
      return rest
    }

    case getType(actions.setDispositionCode): {
      const { mediaItemId, code } = action.payload

      const out = state[mediaItemId]

      if (out) {
        return {
          ...state,
          [mediaItemId]: { ...out, selectedCode: code },
        }
      }
      break;
    }

    case getType(actions.setDispositionCodeDeferDate): {
      const { mediaItemId, deferDate } = action.payload

      const out = state[mediaItemId]

      if (out) {
        return {
          ...state,
          [mediaItemId]: { ...out, deferDate },
        }
      }
      break;
    }

    default:
      return state
  }
  return state
}

export default combineReducers({
  outboundById,
})

function getRoot(state: StoreState) { return state.outbounds }
function getOutboundCodesById(state: StoreState) { return getRoot(state).outboundById }

export function getOutBoundById(state: StoreState, id: string) {
  return getOutboundCodesById(state)[id]
}
